import styled from 'styled-components';

const UserNameRow = styled.div`
  width: 100%;
  flex: 1;
`;

export default UserNameRow;
